"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var EntityType;
(function (EntityType) {
    // Programmatic Entity
    EntityType["LOCAL"] = "LOCAL";
    // Entity trained in LUIS
    EntityType["LUIS"] = "LUIS";
    // Enumeration
    EntityType["ENUM"] = "ENUM";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
exports.makeNegative = function (entity, positiveId) { return (__assign({}, entity, { negativeId: null, positiveId: positiveId })); };
function isPrebuilt(entity) {
    return (entity.entityName === "builtin-" + entity.entityType.toLowerCase());
}
exports.isPrebuilt = isPrebuilt;
exports.MAX_ENUM_VALUES = 5;
//# sourceMappingURL=Entity.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@conversationlearner/models/dist/Entity.js
// module id = 733
// module chunks = 0